/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DuplicateCandidateReviewDto } from './DuplicateCandidateReviewDto';
import {
    DuplicateCandidateReviewDtoFromJSON,
    DuplicateCandidateReviewDtoFromJSONTyped,
    DuplicateCandidateReviewDtoToJSON,
    DuplicateCandidateReviewDtoToJSONTyped,
} from './DuplicateCandidateReviewDto';

/**
 * 
 * @export
 * @interface MdmDuplicateCandidatesListResponse
 */
export interface MdmDuplicateCandidatesListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MdmDuplicateCandidatesListResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<DuplicateCandidateReviewDto>}
     * @memberof MdmDuplicateCandidatesListResponse
     */
    data?: Array<DuplicateCandidateReviewDto>;
    /**
     * 
     * @type {number}
     * @memberof MdmDuplicateCandidatesListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmDuplicateCandidatesListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmDuplicateCandidatesListResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidatesListResponse
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the MdmDuplicateCandidatesListResponse interface.
 */
export function instanceOfMdmDuplicateCandidatesListResponse(value: object): value is MdmDuplicateCandidatesListResponse {
    return true;
}

export function MdmDuplicateCandidatesListResponseFromJSON(json: any): MdmDuplicateCandidatesListResponse {
    return MdmDuplicateCandidatesListResponseFromJSONTyped(json, false);
}

export function MdmDuplicateCandidatesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmDuplicateCandidatesListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(DuplicateCandidateReviewDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function MdmDuplicateCandidatesListResponseToJSON(json: any): MdmDuplicateCandidatesListResponse {
    return MdmDuplicateCandidatesListResponseToJSONTyped(json, false);
}

export function MdmDuplicateCandidatesListResponseToJSONTyped(value?: MdmDuplicateCandidatesListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(DuplicateCandidateReviewDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'errorMessage': value['errorMessage'],
    };
}

